module.exports = __webpack_public_path__ + "img/no_ambient_weak_light.21e45f80.png";